import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import Markdown from 'markdown-to-jsx';
import { ChildrenPropType, StylePropType } from '../../services/proptypes';
import { classNames } from '../../utils/classname';
var defaultProps = {
  className: '',
  style: {},
  content: '',
  show: true
};
export default function MarkdownContent(_ref) {
  var className = _ref.className,
    style = _ref.style,
    content = _ref.content,
    children = _ref.children,
    show = _ref.show;
  var finalContent = content || children;
  var hasNoContent = _isEmpty(finalContent);
  if (hasNoContent || !show) {
    return null;
  }
  var finalClassName = classNames(_defineProperty({
    'markdown-content-container': true
  }, className, true));
  return /*#__PURE__*/React.createElement(Markdown, {
    className: finalClassName,
    style: style,
    options: {
      wrapper: 'div',
      forceWrapper: true
    }
  }, finalContent);
}
MarkdownContent.defaultProps = defaultProps;